import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { CryptoService } from '../crypto/crypto.services';
import { FileListUpdate } from '../file-list-update/fileListUpdate.service';
import { DocumentTypeConverter } from './document-type.interface';
import { UserDocumentConverter } from './user-document.interface';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class MxconnectionService {
  constructor(
    private dialog: MatDialog,
    private fileListUpdate: FileListUpdate,
    private readonly httpService: AmplifyHttpClient,
    private converter: DocumentTypeConverter,
    private userDocConverter: UserDocumentConverter,
    private cryptoService: CryptoService
  ) {}

  connectwithMX(userId, w_id = null) {
    let url = `api/user/mx-widgetURL/${userId}`;
    if (w_id != null) {
      url = url + `?w_id=${w_id}`;
    }
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  updateToMX(data) {
    const url = `api/user/mx-widgetURL-institution`;
    return this.httpService.post(url, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getUserStatusMX(userId, w_id = null, apiSource = 'mx') {
    let url = `api/user/api-status/${userId}/${apiSource}`;
    if (w_id != null) {
      url = url + `?w_id=${w_id}`;
    }
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getLinkedMXAccount(formId, apiSource?: string) {
    const url = apiSource ? `api/vault/linked-financial-account/${formId}/${apiSource}` : `api/vault/linked-financial-account/${formId}`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  deleteUserMemberAccount(data) {
    const url = `api/user/delete-mxMemberAccount`;
    return this.httpService.post(url, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
}
